import React from 'react';
import { Box, Text } from 'grommet';

const Marker = ({ text }) => (
  <Box pad="xsmall" background={{ color: 'accent-1' }} width="fit-content">
    <Text size="small">{text}</Text>
  </Box>
);

export default Marker;
